/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetCampaignSettingsQueryResponse,
  GetCampaignSettingsPathParams,
  GetCampaignSettings404,
} from '../types/GetCampaignSettings'

function getGetCampaignSettingsUrl({
  campaign_id,
}: {
  campaign_id: GetCampaignSettingsPathParams['campaign_id']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/emailbison/campaigns/${campaign_id}/settings/` as const,
  }
  return res
}

/**
 * @description Get campaign settings.
 * Returns:
 * Campaign settings if BisonCampaign exists, null otherwise
 * @summary Get campaign settings
 * {@link /api/v1/emailbison/campaigns/:campaign_id/settings/}
 */
export async function getCampaignSettings(
  {
    campaign_id,
  }: { campaign_id: GetCampaignSettingsPathParams['campaign_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetCampaignSettingsQueryResponse,
    ResponseErrorConfig<GetCampaignSettings404>,
    unknown
  >({
    method: 'GET',
    url: getGetCampaignSettingsUrl({ campaign_id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
